// extracted by mini-css-extract-plugin
export var additionalFeatures = "index-module--additionalFeatures--N+wIF";
export var additionalFeaturesHeading = "index-module--additionalFeaturesHeading--fnS2s";
export var attrContainer = "index-module--attrContainer--f-CXV";
export var carousalImageContainer = "index-module--carousalImageContainer--fp4s9";
export var comparisonAttr = "index-module--comparisonAttr--oIEUa";
export var comparisonHeaders = "index-module--comparisonHeaders--B+t1y";
export var comparisonRow = "index-module--comparisonRow--2AciF";
export var comparisons = "index-module--comparisons--qIjk0";
export var container = "index-module--container--vGzjy";
export var featurelist = "index-module--featurelist--gyLUU";
export var label = "index-module--label--Byt4C";
export var measurementImage = "index-module--measurementImage--rnAeK";
export var measurements = "index-module--measurements--iRdjv";
export var mobileMeasurementsImageContainer = "index-module--mobileMeasurementsImageContainer--HKhgp";
export var mobileVariantName = "index-module--mobileVariantName--hd24M";
export var mobileVariantValue = "index-module--mobileVariantValue--3yfHY";
export var set = "index-module--set--UXyID";
export var spec = "index-module--spec--5ZrYU";
export var specs = "index-module--specs--mM2Kj";
export var subValue = "index-module--subValue--OvAHk";
export var title = "index-module--title--e7BWB";
export var value = "index-module--value--GLvbu";
export var variantValueRow = "index-module--variantValueRow--53V78";